import React, {Component} from 'react'
import {
  Box,
  Button,
  Heading,
  Text,
  VStack,
  Grid,
  GridItem,
  Card,
  CardBody,
  Badge,
  Divider,
  HStack,
  Icon,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Textarea,
  IconButton
} from '@chakra-ui/react';
import { ArrowBackIcon, CalendarIcon, EditIcon, WarningIcon, ViewIcon, ViewOffIcon } from '@chakra-ui/icons';
import './SuggestionInfo.css'
import Sidebar from '../Sidebar/Sidebar';
import Navigation from '../../Navigation/Navigation';
import MobileMenu from '../MobileMenu/MobileMenu';
import Footer from '../../../components/Footer/Footer';

class SuggestionInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobileMenuOpen: false,
      isNotSeriousModalOpen: false,
      notSeriousReason: '',
      isSubmittingNotSerious: false,
      showGuestEmail: false
    };
  }

  getStatusColor = (status) => {
    switch(status) {
      case 'submitted': return 'green';
      case 'reviewed': return 'yellow';
      default: return 'gray';
    }
  }

  getStatusText = (status) => {
    switch(status) {
      case 'submitted': return 'Ingediend';
      case 'reviewed': return 'Bekeken';
      default: return 'Onbekend';
    }
  }

  handleStatusChange = (newStatus) => {
    if (this.props.onSuggestionStatusUpdate) {
      this.props.onSuggestionStatusUpdate(this.props.state.selectedSuggestion.id, newStatus);
    }
  }

  handleOpenMobileMenu = () => {
    this.setState({ isMobileMenuOpen: true })
  }

  handleCloseMobileMenu = () => {
    this.setState({ isMobileMenuOpen: false })
  }

  handleToggleGuestEmail = () => {
    this.setState({ showGuestEmail: !this.state.showGuestEmail })
  }

  handleOpenNotSeriousModal = () => {
    this.setState({
      isNotSeriousModalOpen: true,
      notSeriousReason: ''
    })
  }

  handleCloseNotSeriousModal = () => {
    this.setState({
      isNotSeriousModalOpen: false,
      notSeriousReason: '',
      isSubmittingNotSerious: false
    })
  }

  handleNotSeriousReasonChange = (e) => {
    this.setState({ notSeriousReason: e.target.value })
  }

  handleMarkNotSerious = async () => {
    const { notSeriousReason } = this.state
    const suggestion = this.props.state.selectedSuggestion

    if (!this.props.showToast) {
      console.error('showToast prop is missing')
      alert('Er is een fout opgetreden. Herlaad de pagina.')
      return
    }

    if (!notSeriousReason || notSeriousReason.trim().length < 10) {
      this.props.showToast({
        title: 'Uitleg te kort',
        description: 'Uitleg moet minimaal 10 karakters bevatten.',
        status: 'warning',
        duration: 5000,
        isClosable: true
      })
      return
    }

    if (notSeriousReason.length > 500) {
      this.props.showToast({
        title: 'Uitleg te lang',
        description: 'Uitleg mag maximaal 500 karakters bevatten.',
        status: 'warning',
        duration: 5000,
        isClosable: true
      })
      return
    }

    this.setState({ isSubmittingNotSerious: true })

    const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001'

    try {
      const response = await this.props.authenticatedFetch(`${API_URL}/mark_not_serious/${suggestion.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          username: this.props.state.username,
          reason: notSeriousReason.trim()
        })
      })

      const data = await response.json()

      if (data.success) {
        this.props.showToast({
          title: 'Gemarkeerd',
          description: data.message,
          status: 'success',
          duration: 5000,
          isClosable: true
        })

        // Close modal and reload suggestions
        this.handleCloseNotSeriousModal()

        // Go back to all suggestions and reload
        if (this.props.resetSuggestionsPage) {
          this.props.resetSuggestionsPage()
        }
        this.props.onRouteChange('alleSuggesties')
      } else {
        this.props.showToast({
          title: 'Fout',
          description: data.message,
          status: 'error',
          duration: 5000,
          isClosable: true
        })
      }
    } catch (error) {
      console.error('Error marking suggestion as not serious:', error)
      this.props.showToast({
        title: 'Netwerkfout',
        description: 'Kan geen verbinding maken met de server',
        status: 'error',
        duration: 5000,
        isClosable: true
      })
    } finally {
      this.setState({ isSubmittingNotSerious: false })
    }
  }

  componentWillUnmount() {
    // Ensure mobile menu is closed when component unmounts
    if (this.state.isMobileMenuOpen) {
      this.setState({ isMobileMenuOpen: false })
    }
  }
  render () {
    const suggestion = this.props.state.selectedSuggestion;
    
    if (!suggestion) {
      return (
        <>
          <Grid templateColumns="repeat(24, 1fr)" bg="gray.50">
            <GridItem
              as="aside"
              colSpan={{ base: 0, md: 4, lg: 3 }} 
          display={{ base: "none", md: "block" }}
              bg="gray.50"
              minHeight={{ lg: '100vh' }}
              p={0}
            >
              <Sidebar
                getFeed={this.props.getFeed}
                onRouteChange={this.props.onRouteChange}
                userVersion={this.props.state.userVersion}
                onLogout={this.props.onLogout}
              />
            </GridItem>
            <GridItem as="main" colSpan={{ base: 24, md: 20, lg: 21 }} p="10px">
              <Navigation
                state={this.props.state}
                onRouteChange={this.props.onRouteChange}
                getFeed={this.props.getFeed}
                onVersionChange={this.props.onVersionChange}
                onLogout={this.props.onLogout}
                onOpenFeedback={this.props.onOpenFeedback}
                onOpenMobileMenu={this.handleOpenMobileMenu}
              />
              <Box p="40px" textAlign="center">
                <Text fontSize="lg" color="gray.500">
                  Geen suggestie geselecteerd
                </Text>
                <Button 
                  mt={4}
                  leftIcon={<ArrowBackIcon />}
                  onClick={() => this.props.onRouteChange('alleSuggesties')}
                >
                  Terug naar overzicht
                </Button>
              </Box>
        <Footer onRouteChange={this.props.onRouteChange} />

            </GridItem>
          </Grid>
        </>
      );
    }
    
    return (
      <>
        <Grid templateColumns="repeat(24, 1fr)" bg="gray.50">
          <GridItem
            as="aside"
            colSpan={{ base: 0, md: 4, lg: 3 }} 
          display={{ base: "none", md: "block" }}
            bg="gray.50"
            minHeight={{ lg: '100vh' }}
            p={0}
          >
            <Sidebar
              getFeed={this.props.getFeed}
              onRouteChange={this.props.onRouteChange}
              userVersion={this.props.state.userVersion}
              onLogout={this.props.onLogout}
            />
          </GridItem>
          <GridItem
            as="main"
            colSpan={{ base: 24, md: 20, lg: 21 }}
            p="10px"
            display="flex"
            flexDirection="column"
            minHeight="100vh"
          >
            <Navigation
              state={this.props.state}
              onRouteChange={this.props.onRouteChange}
              getFeed={this.props.getFeed}
              onVersionChange={this.props.onVersionChange}
              onLogout={this.props.onLogout}
              onOpenFeedback={this.props.onOpenFeedback}
              onOpenMobileMenu={this.handleOpenMobileMenu}
            />

            <Box p="40px" flex="1">
              <VStack spacing={6} align="stretch">
                <HStack>
                  <Button 
                    leftIcon={<ArrowBackIcon />}
                    variant="ghost"
                    onClick={() => this.props.onRouteChange('alleSuggesties')}
                  >
                    Terug naar overzicht
                  </Button>
                </HStack>
                
                <Card bg="white" shadow="md">
                  <CardBody p={8}>
                    <VStack spacing={6} align="stretch">
                      <Heading as="h2" size="lg" color="gray.700">
                        Suggestie Details
                      </Heading>
                      
                      <Divider />
                      
                      <HStack spacing={8} wrap="wrap">
                        <VStack align="start" spacing={2}>
                          <Text fontSize="sm" color="gray.500" fontWeight="semibold">
                            GEBRUIKER
                          </Text>
                          {suggestion.is_guest ? (
                            <Badge colorScheme="purple" fontSize="sm">Gast</Badge>
                          ) : (
                            <Text fontSize="lg" fontWeight="semibold" color="gray.700">
                              {suggestion.username || 'Onbekend'}
                            </Text>
                          )}
                        </VStack>

                        <VStack align="start" spacing={2}>
                          <Text fontSize="sm" color="gray.500" fontWeight="semibold">
                            DATUM
                          </Text>
                          <HStack>
                            <Icon as={CalendarIcon} color="gray.400" />
                            <Text color="gray.700">
                              {suggestion.created_at ?
                                new Date(suggestion.created_at).toLocaleDateString('nl-NL', {
                                  day: 'numeric',
                                  month: 'long',
                                  year: 'numeric'
                                }) :
                                'Onbekend'}
                            </Text>
                          </HStack>
                        </VStack>

                        <VStack align="start" spacing={2}>
                          <Text fontSize="sm" color="gray.500" fontWeight="semibold">
                            STATUS
                          </Text>
                          <Badge
                            colorScheme={this.getStatusColor(suggestion.status)}
                            variant="solid"
                            fontSize="sm"
                            px={3}
                            py={1}
                          >
                            {this.getStatusText(suggestion.status)}
                          </Badge>
                        </VStack>

                        {suggestion.is_guest && suggestion.guest_email && (
                          <VStack align="start" spacing={2}>
                            <Text fontSize="sm" color="gray.500" fontWeight="semibold">
                              EMAIL
                            </Text>
                            <HStack spacing={2}>
                              <Box
                                bg="gray.100"
                                px={3}
                                py={1}
                                borderRadius="md"
                                border="1px"
                                borderColor="gray.300"
                              >
                                <Text fontSize="sm" color="gray.700" fontFamily="monospace">
                                  {this.state.showGuestEmail ? suggestion.guest_email : '••••••••••••'}
                                </Text>
                              </Box>
                              <IconButton
                                size="sm"
                                variant="ghost"
                                icon={this.state.showGuestEmail ? <ViewOffIcon /> : <ViewIcon />}
                                onClick={this.handleToggleGuestEmail}
                                aria-label={this.state.showGuestEmail ? 'Verberg email' : 'Toon email'}
                              />
                            </HStack>
                          </VStack>
                        )}
                      </HStack>
                      
                      <Divider />
                      
                      <VStack align="start" spacing={4}>
                        <Text fontSize="sm" color="gray.500" fontWeight="semibold">
                          SUGGESTIE TEKST
                        </Text>
                        <Box
                          bg="neutral.50"
                          p={6}
                          borderRadius="md"
                          border="1px"
                          borderColor="gray.200"
                          width="100%"
                        >
                          <Text color="gray.800" lineHeight="1.8" fontSize="md">
                            {suggestion.text}
                          </Text>
                        </Box>
                      </VStack>
                      
                      <Divider />

                      {/* Show not serious warning if marked */}
                      {suggestion.marked_not_serious && (
                        <Box
                          bg="red.50"
                          p={4}
                          borderRadius="md"
                          border="1px"
                          borderColor="red.200"
                        >
                          <VStack align="start" spacing={2}>
                            <HStack>
                              <Icon as={WarningIcon} color="red.500" />
                              <Text fontSize="md" color="red.700" fontWeight="bold">
                                Gemarkeerd als niet serieus
                              </Text>
                            </HStack>
                            <Text fontSize="sm" color="red.600">
                              <strong>Reden:</strong> {suggestion.not_serious_reason}
                            </Text>
                            {suggestion.marked_not_serious_at && (
                              <Text fontSize="xs" color="red.500">
                                Gemarkeerd op {new Date(suggestion.marked_not_serious_at).toLocaleDateString('nl-NL', {
                                  day: 'numeric',
                                  month: 'long',
                                  year: 'numeric',
                                  hour: '2-digit',
                                  minute: '2-digit'
                                })}
                              </Text>
                            )}
                          </VStack>
                        </Box>
                      )}

                      <VStack align="start" spacing={4} width="100%">
                        <Text fontSize="sm" color="gray.500" fontWeight="semibold">
                          ACTIES
                        </Text>

                        {/* Mobile: Stack vertically */}
                        <VStack spacing={3} width="100%" align="stretch" display={{ base: "flex", md: "none" }}>
                          {suggestion.status === 'submitted' && (
                            <Button
                              colorScheme="yellow"
                              leftIcon={<EditIcon />}
                              onClick={() => this.handleStatusChange('reviewed')}
                              size="sm"
                              width="100%"
                            >
                              Markeer als bekeken
                            </Button>
                          )}
                          {suggestion.status === 'reviewed' && (
                            <Text fontSize="md" color="green.500" fontWeight="semibold">
                              ✓ Deze suggestie is bekeken
                            </Text>
                          )}
                          {!suggestion.is_guest && (
                            <Button
                              colorScheme="purple"
                              leftIcon={<EditIcon />}
                              onClick={() => this.props.onSendMessageToUser && this.props.onSendMessageToUser(suggestion.username, suggestion)}
                              size="sm"
                              width="100%"
                            >
                              Bericht sturen
                            </Button>
                          )}
                          {suggestion.is_guest && (
                            <Text fontSize="sm" color="gray.500" fontStyle="italic">
                              Gastgebruikers kunnen geen berichten ontvangen
                            </Text>
                          )}
                          {!suggestion.marked_not_serious && (
                            <Button
                              colorScheme="red"
                              variant="outline"
                              leftIcon={<WarningIcon />}
                              onClick={this.handleOpenNotSeriousModal}
                              size="sm"
                              width="100%"
                            >
                              Markeer als niet serieus
                            </Button>
                          )}
                        </VStack>

                        {/* Desktop: Horizontal layout with left and right groups */}
                        <Box width="100%" display={{ base: "none", md: "flex" }} justifyContent="space-between" alignItems="center">
                          {/* Left side: Markeer als bekeken and Bericht sturen */}
                          <HStack spacing={3}>
                            {suggestion.status === 'submitted' && (
                              <Button
                                colorScheme="yellow"
                                leftIcon={<EditIcon />}
                                onClick={() => this.handleStatusChange('reviewed')}
                                size="md"
                              >
                                Markeer als bekeken
                              </Button>
                            )}
                            {suggestion.status === 'reviewed' && (
                              <Text fontSize="lg" color="green.500" fontWeight="semibold">
                                ✓ Deze suggestie is bekeken
                              </Text>
                            )}
                            {!suggestion.is_guest && (
                              <Button
                                colorScheme="purple"
                                leftIcon={<EditIcon />}
                                onClick={() => this.props.onSendMessageToUser && this.props.onSendMessageToUser(suggestion.username, suggestion)}
                                size="md"
                              >
                                Bericht sturen
                              </Button>
                            )}
                            {suggestion.is_guest && (
                              <Text fontSize="sm" color="gray.500" fontStyle="italic">
                                Gastgebruikers kunnen geen berichten ontvangen
                              </Text>
                            )}
                          </HStack>

                          {/* Right side: Markeer als niet serieus */}
                          {!suggestion.marked_not_serious && (
                            <Button
                              colorScheme="red"
                              variant="outline"
                              leftIcon={<WarningIcon />}
                              onClick={this.handleOpenNotSeriousModal}
                              size="md"
                            >
                              Markeer als niet serieus
                            </Button>
                          )}
                        </Box>
                      </VStack>
                    </VStack>
                  </CardBody>
                </Card>
              </VStack>
            </Box>
        <Footer onRouteChange={this.props.onRouteChange} />

          </GridItem>
        </Grid>
      
        {/* Mobile Menu Drawer */}
        <MobileMenu
          isOpen={this.state.isMobileMenuOpen}
          onClose={this.handleCloseMobileMenu}
          onRouteChange={this.props.onRouteChange}
          userVersion={this.props.state.userVersion}
          resetSuggestionsPage={this.props.resetSuggestionsPage}
        />

        {/* Mark as Not Serious Modal */}
        <Modal
          isOpen={this.state.isNotSeriousModalOpen}
          onClose={this.handleCloseNotSeriousModal}
          size="lg"
        >
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Markeer suggestie als niet serieus</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <VStack spacing={4} align="stretch">
                <Text fontSize="sm" color="gray.600">
                  Leg uit waarom deze suggestie als niet serieus wordt beschouwd. Deze uitleg zal worden opgeslagen.
                </Text>
                <Textarea
                  placeholder="Uitleg (minimaal 10 karakters)..."
                  value={this.state.notSeriousReason}
                  onChange={this.handleNotSeriousReasonChange}
                  rows={6}
                  maxLength={500}
                />
                <Text fontSize="xs" color="gray.500" textAlign="right">
                  {this.state.notSeriousReason.length} / 500 karakters
                </Text>
              </VStack>
            </ModalBody>
            <ModalFooter>
              <Button
                variant="ghost"
                mr={3}
                onClick={this.handleCloseNotSeriousModal}
                isDisabled={this.state.isSubmittingNotSerious}
              >
                Annuleren
              </Button>
              <Button
                colorScheme="red"
                onClick={this.handleMarkNotSerious}
                isLoading={this.state.isSubmittingNotSerious}
                loadingText="Markeren..."
              >
                Markeer als niet serieus
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </>
    )
  }
}

export default SuggestionInfo